/* Berniture Easify Fabric Swatches — Cart */
window.BRNEasifySwatchMap = {"jp1":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_1.jpg?v=1785279568","jp2":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_2.jpg?v=1785279676","jp3":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_3.jpg?v=1785279681","jp4":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_4.jpg?v=1785280997","jp5":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_5.jpg?v=1785346700","jp6":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_6.jpg?v=1785346790","jp12":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_12.jpg?v=1785346974","jp22":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_22.jpg?v=1785347209","jp37":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_37.jpg?v=1785347323","jp29":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/JP_29.jpg?v=1785347621","lucky 10":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_10.jpg?v=1785881938","lucky 1":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_1.jpg?v=1785881779","lucky 8":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_8.jpg?v=1785881836","lucky 9":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_9.jpg?v=1785881883","lucky 11":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_11.jpg?v=1785881975","lucky 13":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_13.jpg?v=1785882015","lucky 16":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_16.jpg?v=1785882057","lucky 17":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_17.jpg?v=1785882102","lucky 22":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_22.jpg?v=1785882151","lucky 21":"https://cdn.shopify.com/s/files/1/0814/2477/7473/files/Lucky_21.jpg?v=1785882194"};

(function() {
  'use strict';

  function normalize(v) {
    return String(v || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function escapeHtml(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function swatchUrl(value) {
    return window.BRNEasifySwatchMap[normalize(value)] || '';
  }

  function apply(root) {
    root = root || document;

    root.querySelectorAll(
      '.brn-cart-item__variant > span,' +
      '.brn-cart-item__variant'
    ).forEach(function(node) {

      if (node.dataset.brnFabricSwatch === '1') return;

      // Never process content generated by this script itself.
      if (node.closest('.brn-easify-cart-fabric')) return;

      if (node.children.length) return;

      const raw = (node.textContent || '').trim();
      if (!raw) return;

      let value = raw;

      // Example: LUCKY : Lucky 10
      const parts = raw.match(/^([^:：]+)\s*[:：]\s*(.+)$/);
      if (parts) value = parts[2].trim();

      const url = swatchUrl(value);
      if (!url) return;

      node.dataset.brnFabricSwatch = '1';

      node.innerHTML =
        '<span class="brn-easify-cart-fabric" ' +
        'style="display:inline-flex;align-items:center;gap:8px;margin-top:5px;">' +
          '<img src="' + escapeHtml(url) + '" ' +
          'alt="' + escapeHtml(value) + '" ' +
          'width="42" height="42" loading="lazy" ' +
          'style="width:42px;height:42px;object-fit:cover;' +
          'border-radius:5px;border:1px solid rgba(0,0,0,.12);">' +
          '<span style="font-size:12px;">' +
            escapeHtml(value) +
          '</span>' +
        '</span>';
    });
  }

  function init() {
    apply(document);

    const drawer = document.getElementById('brn-cart-drawer');

    if (drawer) {
      const observerOptions = {
        childList: true,
        subtree: true
      };

      const observer = new MutationObserver(function() {
        // Prevent our own DOM changes from recursively triggering
        // another swatch-render pass.
        observer.disconnect();

        apply(drawer);

        observer.observe(drawer, observerOptions);
      });

      observer.observe(drawer, observerOptions);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
